

export const videoList = [
    {
        name: '光学生物测量仪(天鹅)',
        poster: "http://file.visionhealthmed.com/file/swan.png",
        subtext: "1s快速精准测量创新音画吸引系统",
        list: [
            {
                name: "半自动生物测量仪",
                video: [
                    {
                        name: '安装视频(主机、附件)',
                        url: "http://file.visionhealthmed.com/file/半自动生物测量仪的安装.mp4"
                    },
                    {
                        name: '使用操作视频',
                        url: "http://file.visionhealthmed.com/file/半自动生物测量仪的使用.mp4"
                    },
                ]
            },
            {
                name: "全自动生物测量仪",
                video: [
                    {
                        name: '安装视频(主机、附件)',
                        url: "http://file.visionhealthmed.com/file/半自动生物测量仪的安装.mp4"
                    },
                    {
                        name: '使用操作视频',
                        url: "http://file.visionhealthmed.com/file/全自动700系列测量操作流程.mp4"
                    },
                ]
            },
            {
                name: "打印机的连接及维护",
                url: '',
                video: [
                    {
                        name: "打印机的连接及维护",
                        url: "http://file.visionhealthmed.com/file/打印机的连接及维护.mp4"
                    }
                ]
            },
            // {
            //     name: "四、参数临床应用",
            //     url: '',
            //     video: [
            //         {
            //             name: "参数临床应用",
            //             url: ""
            //         }
            //     ]
            // }
        ]
    },
    {
        name: "视力筛查仪(天鸽)",
        poster: "http://file.visionhealthmed.com/file/columba.png",
        subtext: '0.4s极速筛查创新音画吸引系统',
        list: [
            {
                name: "天鸽视力筛查仪拍摄流程",
                url: '',
                video: [
                    {
                        name: "天鸽视力筛查仪拍摄流程",
                        url: "http://file.visionhealthmed.com/file/视力筛查仪的使用.mp4"
                    }
                ]
            },
            {
                name: "热敏打印机连接与设置",
                url: '',
                video: [
                    {
                        name: "热敏打印机连接与设置",
                        url: "http://file.visionhealthmed.com/file/热敏打印机连接与设置.mp4"
                    }
                ]
            },
            {
                name: "常用功能",
                url: '',
                video: [
                    {
                        name: "常用功能",
                        url: "http://file.visionhealthmed.com/file/天鸽_常用功能.mp4"
                    }
                ]
            },
            {
                name: "校园/大规模筛查流程",
                url: '',
                video: [
                    {
                        name: "校园/大规模筛查流程",
                        url: "http://file.visionhealthmed.com/file/天鸽_校园大规模筛查流程.mp4"
                    }
                ]
            },
            {
                name: "常见问题及排查",
                url: '',
                video: [
                    {
                        name: "常见问题及排查",
                        url: "http://file.visionhealthmed.com/file/天鸽_常见问题及排查.mp4"
                    }
                ]
            },
            {
                name: "筛查箱反射镜调整",
                url: '',
                video: [
                    {
                        name: "筛查箱反射镜调整",
                        url: "http://file.visionhealthmed.com/file/天鸽_筛查箱反射镜调整.mp4"
                    }
                ]
            },
            // {
            //     name: "五、参数临床应用",
            //     url: '',
            //     video: [
            //         {
            //             name: "参数临床应用",
            //             url: ""
            //         }
            //     ]
            // },
        ]
    },
    {
        name: '视功能检查训练仪(星豚)',
        poster: "https://visionhealthmed.com/file/ProductVideo/starton.png",
        subtext: "",
        list: [
            {
                name: "星豚视功能检查训练仪操作流程",
                video: [
                    {
                        name: '星豚视功能检查训练仪操作流程',
                        url: "http://file.visionhealthmed.com/file/星豚操作流程.mp4"
                    },
                ]
            },
        ]
    },
];